type FileNameClient = {
  first_name?: string | null;
  last_name?: string | null;
};

type FileNameCalculation = {
  name?: string | null;
  calculation_created_at?: string | null;
  parent_id?: number | null;
};

type BuildCalculationFileNameParams = {
  prefix: string;
  calculation?: FileNameCalculation | null;
  client?: FileNameClient | null;
  includeCopyMarker?: boolean;
};

function sanitizePart(value: string): string {
  return value
    .trim()
    .replace(/[\\/:*?"<>|]/g, '-')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/-+/g, '-')
    .replace(/^[_-]+|[_-]+$/g, '');
}

function formatCalculationDate(value?: string | null): string {
  if (!value) {
    return '';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const pad = (n: number) => String(n).padStart(2, '0');

  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `_${pad(date.getHours())}-${pad(date.getMinutes())}`
  );
}

function buildClientPart(client?: FileNameClient | null): string {
  if (!client) {
    return '';
  }

  const fullName = [client.first_name, client.last_name]
    .map((part) => (part ?? '').trim())
    .filter(Boolean)
    .join(' ');

  return sanitizePart(fullName);
}

export function buildCalculationFileName({
  prefix,
  calculation,
  client,
  includeCopyMarker = false,
}: BuildCalculationFileNameParams): string {
  const parts: string[] = [sanitizePart(prefix)];

  const clientPart = buildClientPart(client);
  if (clientPart) {
    parts.push(clientPart);
  }

  const namePart = sanitizePart(calculation?.name ?? '');
  if (namePart) {
    parts.push(namePart);
  }

  if (includeCopyMarker && calculation?.parent_id != null) {
    parts.push('kopia');
  }

  const datePart = formatCalculationDate(calculation?.calculation_created_at);
  if (datePart) {
    parts.push(datePart);
  }

  return parts.filter(Boolean).join('_') || sanitizePart(prefix) || 'eksport';
}
